module.exports = __webpack_public_path__ + "img/card-bg-10.6ca0a233.jpg";